export const TOTAL_URL_CHECKS_COUNT = 55;
export const TOTAL_DOMAIN_CHECKS_COUNT = 16;

/**
 * Threshold inclusive
 */
export const CHECK_MEDIUM_PRIORITY_THRESHOLD = 4;
/**
 * Threshold inclusive
 */
export const CHECK_HIGH_PRIORITY_THRESHOLD = 8;

/**
 * Threshold inclusive
 */
export const DOMAIN_MEDIUM_SCORE_THRESHOLD = 50;
/**
 * Threshold inclusive
 */
export const DOMAIN_HIGH_SCORE_THRESHOLD = 75;

/**
 * Threshold inclusive
 */
export const URL_MEDIUM_SCORE_THRESHOLD = 50;
/**
 * Threshold inclusive
 */
export const URL_HIGH_SCORE_THRESHOLD = 75;

export const SERVICEABLE_URLS_ON_PAGE = 25;

export const SITEMAP_IMPORT_PROCESS_POLLING_TIME_MS = 5000;

export const URL_BATCH_ANALYSIS_PROCESS_POLLING_TIME_MS = 30000;

export const DOMAIN_ANALYSIS_PROCESS_POLLING_TIME_MS = 15000;

export const FAILED_CHECKS_POLLING_TIME_MS = 30000;

export const DPA_DASHBOARD_POLLING_TIME_MS = 30000;

export const SERVICEABLE_URLS_POLLING_TIME_MS = 30000;

export const WEBSITE_STATUS_POLLING_TIME_MS = 5000;
